/**
 * Paneles de PrimeNG que cuelgan del `body` (`appendTo="body"`) y que un `p-dialog` no ve como suyos.
 * Con `closeOnEscape` encendido, la tecla Escape que cierra uno de estos paneles llega TAMBIÉN al
 * `document` y el diálogo se cierra entero con lo capturado (QA-11): el diálogo apaga `closeOnEscape` y
 * decide él mismo, preguntando aquí si hay un panel abierto antes de cerrarse.
 */
const PRIMENG_OVERLAY_SELECTOR = '.p-multiselect-panel, .p-datepicker, .p-autocomplete-panel, .p-dropdown-panel'

export const hasOpenOverlay = (doc: Document): boolean => doc.querySelector(PRIMENG_OVERLAY_SELECTOR) !== null
